import React from 'react';
import { Row, Col } from 'react-bootstrap';
import RequiredField from '../../../SharedComponents/RequiredField/RequiredField';
import {useTranslation} from 'react-i18next'

const ContactFormSection = ({ formData, handleChange, handleFileChange, formErrors, touched }) => {
    const {t} = useTranslation('contact')

    const {
        call_sign = '',
        office_phone = '',
        dect_phone = '',
        mobile_phone = '',
        sat_number = '',
        primary_emergency_contact_name = '',
        primary_emergency_contact_number = '',
        secondary_emergency_contact_name = '',
        secondary_emergency_contact_number = '',
        proof_of_life = null,
    } = formData || {};

    // Helper function to determine if field should show error styling
    const getFieldClasses = (fieldName, isRequired = false) => {
        const hasError = formErrors[fieldName] && touched[fieldName];
        const isEmpty = !formData[fieldName]?.toString().trim();

        let classes = 'form-control';

        if (hasError || (isRequired && isEmpty)) {
            classes += ' is-invalid';
        }

        return classes;
    };

    // Helper function to get field style for required fields
    const getFieldStyle = (fieldName, isRequired = false) => {
        const isEmpty = !formData[fieldName]?.toString().trim();

        if (isRequired && isEmpty) {
            return {
                border: '2px solid #dc3545',
                borderRadius: '0.375rem'
            };
        }

        return {};
    };

    return (
        <div>
            <Row className="mb-3">
                <Col md={6}>
                    <RequiredField
                        label={t('callSign')}
                        name="call_sign"
                        value={call_sign}
                        onChange={handleChange}
                        error={formErrors.call_sign}
                        // isRequired={true}
                        placeholder={t('enterCallSign')}
                    />
                </Col>
                <Col md={6}>
                    <RequiredField
                        label={t('officePhone')}
                        name="office_phone"
                        value={office_phone}
                        onChange={handleChange}
                        placeholder={t('enterOfficePhone')}
                    />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={6}>
                    <RequiredField
                        label={t('dectPhone')}
                        name="dect_phone"
                        value={dect_phone}
                        onChange={handleChange}
                        placeholder={t('enterDectPhone')}
                    />
                </Col>
                <Col md={6}>
                    <RequiredField
                        label={t('mobilePhone')}
                        name="mobile_phone"
                        value={mobile_phone}
                        onChange={handleChange}
                        placeholder={t('enterMobilePhone')}
                    />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={6}>
                    <RequiredField
                        label={t('satelliteNumber')}
                        name="sat_number"
                        value={sat_number}
                        onChange={handleChange}
                        placeholder={t('enterSatelliteNumber')}
                    />
                </Col>
                <Col md={6}>
                    <div className="mb-3">
                        <label htmlFor="proof_of_life" className="form-label">
                            {t('proofOfLife')}
                        </label>
                        <input
                            id="proof_of_life"
                            name="proof_of_life"
                            type="file"
                            onChange={handleFileChange}
                            className={getFieldClasses('proof_of_life')}
                        />
                        {formErrors.proof_of_life && (
                            <div className="invalid-feedback">{formErrors.proof_of_life}</div>
                        )}
                    </div>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={6}>
                    <div className="mb-3">
                        <label htmlFor="primary_emergency_contact_name" className="form-label">
                            {t('primaryEmergencyContactName')}
                            <span className="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="primary_emergency_contact_name"
                            name="primary_emergency_contact_name"
                            type="text"
                            value={primary_emergency_contact_name}
                            onChange={handleChange}
                            className={getFieldClasses('primary_emergency_contact_name', true)}
                            style={getFieldStyle('primary_emergency_contact_name', true)}
                            placeholder={t('enterPrimaryContactName')}
                        />
                        {formErrors.primary_emergency_contact_name && (
                            <div className="invalid-feedback">{formErrors.primary_emergency_contact_name}</div>
                        )}
                    </div>
                </Col>
                <Col md={6}>
                    <div className="mb-3">
                        <label htmlFor="primary_emergency_contact_number" className="form-label">
                            {t('primaryEmergencyContactNumber')}
                            <span className="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="primary_emergency_contact_number"
                            name="primary_emergency_contact_number"
                            type="text"
                            value={primary_emergency_contact_number}
                            onChange={handleChange}
                            className={getFieldClasses('primary_emergency_contact_number', true)}
                            style={getFieldStyle('primary_emergency_contact_number', true)}
                            placeholder={t('enterPrimaryContactNumber')}
                        />
                        {formErrors.primary_emergency_contact_number && (
                            <div className="invalid-feedback">{formErrors.primary_emergency_contact_number}</div>
                        )}
                    </div>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={6}>
                    <RequiredField
                        label={t('secondaryEmergencyContactName')}
                        name="secondary_emergency_contact_name"
                        value={secondary_emergency_contact_name}
                        onChange={handleChange}
                        placeholder={t('enterSecondaryContactName')}
                    />
                </Col>
                <Col md={6}>
                    <RequiredField
                        label={t('secondaryEmergencyContactNumber')}
                        name="secondary_emergency_contact_number"
                        value={secondary_emergency_contact_number}
                        onChange={handleChange}
                        placeholder={t('enterSecondaryContactNumber')}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default ContactFormSection;